import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState, ListStateItem, ListModuleItem} from '@/store/shared'
import ProductName from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

interface ProductNameState extends ListStateItem<ProductName>{
    editProductName:ProductName;
    permissions:Array<string>;
    productNameSelect:Array<any>;
}
class ProductNameModule extends ListModuleItem<ProductNameState,any,ProductName>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editProductName:new ProductName(),
        permissions:new Array<string>(),
        productNameSelect:new Array<any>()
    }

    actions={
        async getAll(context:ActionContext<ProductNameState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('/services/app/ProductName/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<ProductName>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<ProductNameState,any>,payload:any){
            await $http.post('services/app/ProductName/Create',payload.data);
        },
        async update(context:ActionContext<ProductNameState,any>,payload:any){
            await $http.put('services/app/ProductName/Update',payload.data);
        },
        async delete(context:ActionContext<ProductNameState,any>,payload:any){
            await $http.delete('services/app/ProductName/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ProductNameState,any>,payload:any){
            let reponse=await $http.get('services/app/ProductName/Get?Id='+payload.id);
            context.state.editProductName = reponse.data.result;
            return reponse.data.result;
        },
        async getProductNameSelect(context:ActionContext<ProductNameState,any>,payload:any){
            let reponse=await $http.get('services/app/ProductName/GetProductNameSelect');
            context.state.productNameSelect = reponse.data.result;
        },
    };
    overrideMutations={
        edit(state:ProductNameState,productName:ProductName){
            state.editProductName=productName;
        }
    }
}
const productNameModule=new ProductNameModule();
export default productNameModule;